import type { Dye } from '../types/products';

/**
 * Solvent-soluble dyes for fuel and petroleum products.
 * `color` is a hex swatch used purely for UI presentation.
 */
export const dyes: Dye[] = [
  {
    name: 'Solvent Yellow 107',
    color: '#E9C000',
    applications: 'Lubricants, diesel, gasolines, mineral oil',
    purpose: 'Yellow coloration for identification or branding',
  },
  {
    name: 'Solvent Yellow 124',
    color: '#E4B200',
    applications: 'Diesel, heating oil, gas oil',
    purpose: 'Yellow coloration for taxed / untaxed fuel distinction',
  },
  {
    name: 'Solvent Yellow CS',
    color: '#EFCD2E',
    applications: 'Lubricants, gasolines, mineral oil',
    purpose: 'Yellow coloration for identification',
  },
  {
    name: 'Solvent Orange 98',
    color: '#E67319',
    applications: 'Lubricants, aviation fuel, jet oil',
    purpose: 'Orange coloration for identification or safety',
  },
  {
    name: 'Solvent Red 19-E',
    color: '#C62828',
    applications: 'Diesel, aviation fuel, lubricants',
    purpose: 'Red coloration for tax compliance or identification',
  },
  {
    name: 'Solvent Red 161',
    color: '#D32F2F',
    applications: 'Diesel, gas oil, lubricants',
    purpose: 'Red coloration for identification or branding',
  },
  {
    name: 'Solvent Red 164',
    color: '#B71C1C',
    applications: 'Lubricants, transmission fluids, gasolines',
    purpose: 'Red coloration for industrial / automotive use',
  },
  {
    name: 'Solvent Red CR',
    color: '#A31515',
    applications: 'Diesel, kerosene, mineral oil',
    purpose: 'Red coloration for fuel identification',
  },
  {
    name: 'Solvent Red COR',
    color: '#C1272D',
    applications: 'Lubricants, gasolines, jet oil',
    purpose: 'Red coloration for branding or safety',
  },
  {
    name: 'Solvent Violet',
    color: '#6A3FA0',
    applications: 'Lubricants, diesel, mineral oil',
    purpose: 'Violet coloration for identification or aesthetics',
  },
  {
    name: 'Solvent Green 33',
    color: '#2E7D4F',
    applications: 'Aviation fuel, jet oil, lubricants',
    purpose: 'Green coloration for safety / identification',
  },
  {
    name: 'Solvent Blue 79',
    color: '#1565C0',
    applications: 'Lubricants, gasolines, diesel',
    purpose: 'Blue coloration for identification or branding',
  },
  {
    name: 'Solvent Blue 98',
    color: '#0D47A1',
    applications: 'Lubricants, mineral oil, aviation fuel',
    purpose: 'Blue coloration for industrial / aviation use',
  },
  {
    name: 'Solvent Brown',
    color: '#6D4C2B',
    applications: 'Lubricants, diesel, gas oil',
    purpose: 'Brown coloration for identification or branding',
  },
  {
    name: 'Solvent Black',
    color: '#1A1A1A',
    applications: 'Lubricants, kerosene, mineral oil',
    purpose: 'Black coloration for industrial or aesthetics',
  },
];
